<template>
  <div class="container">
    <div class="row s_product_inner">
      <div class="col-lg-6">
        <img :src="product.image_url" class="d-block w-100" alt />
      </div>
      <div class="col-lg-5 offset-lg-1">
        <div class="s_product_text">
          <h3 class="h1">{{product.name}}</h3>
          <hr />
          <h2>${{product.price}}</h2>
          <h5 style="font-size: 12px">+ No Import Fees Deposit + Global Shipping $10</h5>
          <span>
            Arrives: <strong>{{minArrivalDate}} - {{maxArrivalDate}}</strong>
          </span>
          <ul class="list m-4">
            <li class="mb-2">
              <a class="active" href="#">
                <span>
                  <strong>Category</strong>
                </span> : Health
              </a>
            </li>
            <li class="mb-2">
              <a href="#" :class="product.availability? 'text-success': 'text-danger'">
                <span>
                  <strong>Availibility</strong>
                </span>
                : {{product.availability? 'In Stock. Order it now': 'Out of Stock'}}
              </a>
            </li>
            <li>
              <Buy ref="BuyButton" class="main_btn" :item="product" />
            </li>
          </ul>
          <b-row>
            <b-col>
              <b-icon icon="lock-fill" aria-hidden="true"></b-icon> Secure Transaction
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-img thumbnail fluid src="https://scandinavianoutdoor.fi/media/dynamic/uploads/visa-mc-paypal.png" alt="SanitizerWristbands.com Secure Transactions"></b-img>
            </b-col>
          </b-row>

          <hr />
          <ExtraProductInfo />
          <div class="card_area"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Buy from '@/components/BuyButton'
import ExtraProductInfo from '@/components/ExtraProductInfo'
export default {
  components: {
    Buy,
    ExtraProductInfo
  },
  props: ['product'],
  data () {
    return {
      size: 'Medium',
      minArrivalDate: null,
      maxArrivalDate: null
    }
  },
  methods: {
    updateSize (event) {
      const button = this.$refs['BuyButton'].$el
      const size = event.target.value
      button.setAttribute('data-item-custom1-value', size)
    },
    setSuggestedArrivalDates () {
      let incrementDate = function (date, amount) {
        var tmpDate = new Date(date)
        tmpDate.setDate(tmpDate.getDate() + amount)
        let shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let month = shortMonths[tmpDate.getMonth()]
        let day = tmpDate.getDate()
        return `${month} ${day}`
      }
      this.minArrivalDate = incrementDate(new Date(), 12)
      this.maxArrivalDate = incrementDate(new Date(), 26)
    }
  },
  mounted () {
    this.setSuggestedArrivalDates()
  }
}
</script>
<style scoped>
.s_product_text > .card_area > a {
  outline: none;
  line-height: 40px;
  padding: 10px;
  font-size: 0.8em;
  text-align: center;
  text-decoration: none;
  font-weight: 500;
  border-radius: 20px;
  width: 70px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  border-color: 1px solid #797979;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails.vue